var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    polygonButtonFontSize: typography.fontSizeLarge,
    polygonButtonPadding: spacing.xxSmall,
    mainContainerMargin: spacing.xSmall,
    mainContainerBorderWidth: borders.widthSmall,
    mainContainerBorderColor: colors.contrasts.grey1214,
    mainContainerHeaderBorderWidth: borders.widthSmall,
    mainContainerHeaderBorderColor: colors.contrasts.grey1214,
    mainContainerHeaderPadding: spacing.xSmall,
    mainContainerTypePadding: spacing.xSmall,
    mainContainerTypeUnselectedColor: colors.contrasts.white1010,
    mainContainerTypeSelectedColor: colors.contrasts.green4570,
    mainContainerTypeSelectedShadowColor: colors.contrasts.grey1214,
    popoverContentPadding: spacing.xSmall,
    mainContainerActionsMargin: spacing.xSmall,
    mainContainerActionsPadding: spacing.xSmall,
    mainContainerActionsBorderWidth: borders.widthSmall,
    mainContainerActionsBorderColor: colors.contrasts.grey1214,
    mainContainerContentWrapperBackgroundColor: colors.contrasts.grey1111,
    mainContainerContentWrapperPadding: spacing.small,
    fileDropWrapperMargin: spacing.xSmall,
    fileDropContentPadding: spacing.medium,
    fileDropContentBackgroundColor: colors.contrasts.grey1111,
    fileDropContentBorderWidth: borders.widthSmall,
    fileDropContentBorderColor: colors.contrasts.grey1214,
    fileDropContentIconFontSize: typography.fontSizeXXLarge,
    fileDropContentLabelPadding: spacing.xSmall,
    fileDropContentLabelBrowsePadding: spacing.xxSmall,
    fileDropContentLabelBrowseColor: colors.contrasts.blue4570,
    fileDropContentLabelFontFamily: typography.fontFamily,
    modalContentTypesPadding: spacing.small,
    modalContentTypesBackgroundColor: colors.contrasts.grey1111,
    modalContentImageBackgroundColor: colors.contrasts.grey4570
  };
};
export default generateComponentTheme;